export { EloDeviceMobileIcon } from './device-mobile-icon'
